import React from 'react';
export function TermsAndConditions() {
  return <div className="prose prose-sm max-w-none" data-id="element-733">
      <p className="text-gray-600 mb-4" data-id="element-734">
        <strong data-id="element-735">Última actualización:</strong> Enero 2025
      </p>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-736">1. Aceptación de Términos</h3>
      <p className="text-gray-700 mb-4" data-id="element-737">
        Al comprar y utilizar el Sistema 50 Recetas Express, aceptas estos
        términos y condiciones. Si no estás de acuerdo, por favor no utilices
        nuestro producto.
      </p>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-738">
        2. Descripción del Producto
      </h3>
      <p className="text-gray-700 mb-4" data-id="element-739">
        El Sistema 50 Recetas Express es un producto digital que incluye:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-740">
        <li data-id="element-741">120+ recetas de 15 minutos en formato PDF</li>
        <li data-id="element-742">12 menús semanales completos</li>
        <li data-id="element-743">Guía de Batch Cooking Express</li>
        <li data-id="element-744">Listas de compras imprimibles</li>
        <li data-id="element-745">Guía de swaps por país</li>
        <li data-id="element-746">Acceso a comunidad privada</li>
        <li data-id="element-747">Actualizaciones mensuales</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-748">3. Licencia de Uso</h3>
      <p className="text-gray-700 mb-4" data-id="element-749">
        Al comprar el sistema, obtienes una licencia personal y no transferible
        para:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-750">
        <li data-id="element-751">Usar el contenido para tu uso personal y familiar</li>
        <li data-id="element-752">Imprimir las recetas para uso doméstico</li>
        <li data-id="element-753">Acceder a las actualizaciones incluidas</li>
      </ul>
      <p className="text-gray-700 mb-4" data-id="element-754">
        <strong data-id="element-755">NO está permitido:</strong>
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-756">
        <li data-id="element-757">Compartir, revender o distribuir el contenido</li>
        <li data-id="element-758">
          Publicar las recetas en sitios web o redes sociales sin autorización
        </li>
        <li data-id="element-759">Usar el contenido con fines comerciales</li>
        <li data-id="element-760">Modificar y redistribuir el material</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-761">4. Garantía de 30 Días</h3>
      <p className="text-gray-700 mb-4" data-id="element-762">
        Ofrecemos una garantía de satisfacción de 30 días. Si implementas el
        sistema durante un mes y no estás satisfecho, te devolvemos el 100% de
        tu inversión. Para solicitar un reembolso:
      </p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-763">
        <li data-id="element-764">Envía un email a soporte@50recetasexpress.com</li>
        <li data-id="element-765">Indica tu número de orden</li>
        <li data-id="element-766">El reembolso se procesará en 5-7 días hábiles</li>
      </ul>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-767">
        5. Descargo de Responsabilidad
      </h3>
      <p className="text-gray-700 mb-4" data-id="element-768">Los resultados pueden variar según:</p>
      <ul className="list-disc pl-6 mb-4 text-gray-700" data-id="element-769">
        <li data-id="element-770">La consistencia de implementación del sistema</li>
        <li data-id="element-771">Habilidades culinarias previas</li>
        <li data-id="element-772">Disponibilidad de ingredientes en tu región</li>
        <li data-id="element-773">Equipamiento de cocina disponible</li>
      </ul>
      <p className="text-gray-700 mb-4" data-id="element-774">
        Las recetas están diseñadas para personas sin restricciones alimentarias
        graves. Si tienes alergias o condiciones médicas específicas, consulta
        con un profesional de la salud antes de implementar cambios en tu dieta.
      </p>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-775">6. Propiedad Intelectual</h3>
      <p className="text-gray-700 mb-4" data-id="element-776">
        Todo el contenido del Sistema 50 Recetas Express está protegido por
        derechos de autor. Nos reservamos todos los derechos sobre el material.
      </p>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-777">7. Modificaciones</h3>
      <p className="text-gray-700 mb-4" data-id="element-778">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Los cambios serán notificados a través de email y actualizados
        en esta página.
      </p>
      <h3 className="text-lg font-bold mt-6 mb-3" data-id="element-779">8. Contacto</h3>
      <p className="text-gray-700 mb-4" data-id="element-780">
        Para consultas sobre estos términos:
        <br data-id="element-781" />
        <strong data-id="element-782">Email:</strong> legal@50recetasexpress.com
        <br data-id="element-783" />
        <strong data-id="element-784">Soporte:</strong> soporte@50recetasexpress.com
      </p>
    </div>;
}